import { createFileRoute } from '@tanstack/react-router'
import ProjectTeamPage from '@/spa/pages/projects/ProjectTeamPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/team')({
  component: ProjectTeamPage,
  errorComponent: routeErrorComponent,
})
